import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import {NewReleasesOutlined, Verified, VerifiedOutlined} from "@mui/icons-material";
import { RewardStatus } from '../../types/actionModule/instance/actionModuleInstance';

interface RewardStatusIconProps {
    rewardStatus: RewardStatus | null;
}

export const RewardStatusIcon = ({ rewardStatus }: RewardStatusIconProps) => {
    switch (rewardStatus) {
        case null:
        case RewardStatus.NoReward:
            return null;
        case RewardStatus.RewardPending:
            return <HourglassEmptyIcon sx={{ color: "#757575" }} />;
        case RewardStatus.RewardApproved:
            return <VerifiedOutlined sx={{ color: "green" }} />;
        case RewardStatus.RewardDeclined:
            return <NewReleasesOutlined sx={{ color: "red" }} />;
    }
};